module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "live-run"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a18fb7cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 1854
// module chunks = 1